// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previoussurveys_container_previoussurveys__E8m4T{
    display: flex;
    flex:  5 1;
    flex-direction: column;
    align-items: flex-start;
    align-content: center;
    justify-content: center;
    background-color: var(--hsrcBackgroundLight);
    border-radius: 1rem;
    padding: 2rem;
  }
  
  .previoussurveys_featured__zon4l {
    width: 100%;
    display: flex;
    flex: 1 1; 
    flex-direction: row;
    justify-content: space-between;
  } 
  
  .previoussurveys_container_row__SlG8X{
    display: flex;
    flex: 1 1; 
  
    flex-direction: column;
    align-content: center;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: space-around;
  }
  
  .previoussurveys_printviewDialog__HDdAf {
    min-width: 90vw !important;
    max-width: 90vw !important;
  }
  
  .previoussurveys_confirmDialogOverlay__3v0CJ {
    z-index: 10000; 
    pointer-events: none;
  }

  `, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/pages/PreviousSurveys/previoussurveys.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,UAAQ;IACR,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,4CAA4C;IAC5C,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,SAAO;IACP,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,SAAO;;IAEP,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,oBAAoB;EACtB","sourcesContent":[".container_previoussurveys{\r\n    display: flex;\r\n    flex:  5;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    align-content: center;\r\n    justify-content: center;\r\n    background-color: var(--hsrcBackgroundLight);\r\n    border-radius: 1rem;\r\n    padding: 2rem;\r\n  }\r\n  \r\n  .featured {\r\n    width: 100%;\r\n    display: flex;\r\n    flex: 1; \r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n  } \r\n  \r\n  .container_row{\r\n    display: flex;\r\n    flex: 1; \r\n  \r\n    flex-direction: column;\r\n    align-content: center;\r\n    align-items: flex-start;\r\n    align-content: flex-start;\r\n    justify-content: space-around;\r\n  }\r\n  \r\n  .printviewDialog {\r\n    min-width: 90vw !important;\r\n    max-width: 90vw !important;\r\n  }\r\n  \r\n  .confirmDialogOverlay {\r\n    z-index: 10000; \r\n    pointer-events: none;\r\n  }\r\n\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_previoussurveys": `previoussurveys_container_previoussurveys__E8m4T`,
	"featured": `previoussurveys_featured__zon4l`,
	"container_row": `previoussurveys_container_row__SlG8X`,
	"printviewDialog": `previoussurveys_printviewDialog__HDdAf`,
	"confirmDialogOverlay": `previoussurveys_confirmDialogOverlay__3v0CJ`
};
export default ___CSS_LOADER_EXPORT___;
